<template lang="html">

    <div class="filtro container">

        <div class="selector-wrapper row-start" v-if="!orientacion">
            <div class="contenedor-selector">
                <input type="radio" name="type" v-model="data.type" id="radio-type-1" :value="'noticias'">
                <label for="radio-type-1">Noticias</label>
            </div>
            <div class="contenedor-selector">
                <input type="radio" name="type" v-model="data.type" id="radio-type-2" :value="'eventos'">
                <label for="radio-type-2">Eventos</label>
            </div>
        </div>


        <div class="top row-start">
            <input type="text" class="search-box" placeholder="Buscar" v-model="data.search">
            <button class="showmore" :show="showFiltro" @click="showFiltro = !showFiltro"></button>
        </div>
        <div class="bottom row-start ais" v-if="showFiltro">

            <div class="left row-start ais">
                <div class="group">
                    <h3>Área/s</h3>
                    <div class="contenedor-check -radio">
                        <input type="radio" :id="'a-todas'" :value="''" v-model="data.area" name="area">
                        <label :for="'a-todas'">Todas</label>
                    </div>
                    <div class="contenedor-check -radio" v-for="area in atributes.area">
                        <input type="radio" :id="'a'+area.id" :value="area.slug" v-model="data.area" name="area">
                        <label :for="'a'+area.id">{{area.nombre}}</label>
                    </div>
                </div>
                <div class="group">
                    <h3>Categoría/s</h3>
                    <div class="contenedor-check -radio">
                        <input type="radio" :id="'c-todas'" :value="''" v-model="data.categoria" name="area">
                        <label :for="'c-todas'">Todas</label>
                    </div>
                    <div class="contenedor-check -radio" v-for="categoria in atributes.categoria">
                        <input type="radio" :id="'c'+categoria.id" name="categoria" :value="categoria.slug"
                            v-model="data.categoria">
                        <label :for="'c' +categoria.id">{{categoria.nombre}}</label>
                    </div>
                </div>
            </div>
            <div class="right column-start">
                <div class="group">
                    <h3>Titulación</h3>
                    <multiselect v-model="data.titulos" :options="atributes.titulos" :searchable="true"
                        :close-on-select="true" :show-labels="false" :track-by="'nombre'" :value="'slug'"
                        :label="'nombre'" :closeOnSelect="true" :multiple="false"
                        placeholder="Selecciona una titulacion"></multiselect>
                </div>
                <div class="group" v-if="atributes.tags.length != 0">
                    <h3>Etiquetas</h3>

                    <multiselect v-model="data.tags" :options="atributes.tags" :searchable="true"
                        :close-on-select="false" :show-labels="false" :closeOnSelect="true" :multiple="true"
                        placeholder="Selecciona etiquetas"></multiselect>

                </div>
                <div class="group">
                    <h3>Fecha de publicación</h3>
                    <div class="radios-wrapper row-start">
                        <div class="contenedor-check -radio">
                            <input type="radio" name="date" v-model="data.fecha" id="radio-date-1" value="day">
                            <label for="radio-date-1">Últimos 7 días</label>
                        </div>
                        <div class="contenedor-check -radio">
                            <input type="radio" name="date" v-model="data.fecha" id="radio-date-2" value="month">
                            <label for="radio-date-2">Últimos 30 días</label>
                        </div>
                        <div class="contenedor-check -radio">
                            <input type="radio" name="date" v-model="data.fecha" id="radio-date-3" value="ever">
                            <label for="radio-date-3">Siempre</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="group -full">
                <!-- <a @click="reset" class="btn -skull">Borrar</a> -->
            </div>


        </div>

    </div>

</template>

<script lang="js">

    import { mapGetters } from 'vuex';

    import Multiselect from 'vue-multiselect'

    export default {
        name: 'filtro',
        props: ['position', 'orientacion', 'both'],
        mounted() {

            this.setType();

            if(!!this.$route.params.id){
                this.setArea(this.$route.params.id);
            }

        },
        data() {
            return {
                showFiltro: false,
                data: {
                    search: '',
                    area: '',
                    categoria: '',
                    titulos: '',
                    etiquetas: [],
                    fecha: '',
                    type: 'eventos'
                },
            }
        },
        methods: {
            reset() {
                this.data = null;
            },
            setArea(area) {
                this.showFiltro = true;
                setTimeout(e => {
                    this.data.area = area;
                }, 200)
                this.$emit('input', this.data);
            },
            setType() {
                if (!location.search) {
                    this.data.type = 'noticias';
                } else {
                    this.data.type = location.search.split("?")[1]
                }

                this.$emit('input', this.data)
            }
        },
        computed: {
            ...mapGetters({
                getAtributes: 'getAtributes'
            }),
            atributes() {
                let data = {
                    position: this.position,
                    type: (!!!this.both) ? this.data.type : "-1"
                }
                return this.getAtributes(data);
            }
        },
        watch: {
            'data': {
                handler() {
                    this.$emit('input', this.data)
                },
                deep: true
            },
            '$route'(){
                this.setType();
            }
        },
        components: {
            Multiselect
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/filtro.vue